<template>
  <div id="homev2">
    <div class="bg-container">
      <img class="bg-image" src="https://homepage-oss.oss-cn-beijing.aliyuncs.com/h5/yidao_bg.png" alt="">
	  <img class="title-image" src="https://homepage-oss.oss-cn-beijing.aliyuncs.com/h5/yidao_bg_text.png" alt="">
    </div>

    <div class="middle">
      <button v-if="unlogin" class="login" @click="login()">立即登录</button>

      
    </div>
    <Bottom :unlogin="unlogin" />
  </div>
</template>

<script>
// const Base64 = require('js-base64').Base64
import * as sysTools from '../../utils/sysTools'
import Bottom from '@/layout/Bottom'
import {
	islogin,
	logout
//  evtlogadd
} from '@/api/theApi'

export default {
	components: {
		Bottom
	},
	data() {
		return {
			icons: {
				home: {
					name: '首页',
					active: 'https://static.ainvestcn.com/h5/icon/home-icon-a.png',
					normal: 'https://static.ainvestcn.com/h5/icon/home-icon.png'
				},
				mall: {
					name: '投顾商城',
					active: 'https://static.ainvestcn.com/h5/icon/shop-icon-a.png',
					normal: 'https://static.ainvestcn.com/h5/icon/shop-icon.png'
				},
				user: {
					name: '用户中心',
					active: 'https://static.ainvestcn.com/h5/icon/user-icon-a.png',
					normal: 'https://static.ainvestcn.com/h5/icon/user-icon.png'
				},				
				jsyl: {
					name: '金声玉亮',
					active: 'https://static.ainvestcn.com/h5/icon/jsyl-icon.png',
					normal: 'https://static.ainvestcn.com/h5/icon/jsyl-icon.png'
				}
			},
		
			unlogin: true,
			active: 0
		}
	},
	computed: {
		theUA() {
			return sysTools.getUA()
		},

		isWeiXin() {
			if (this.theUA.indexOf('micromessenger') !== -1) {
				return true
			} else {
				return false
			}
		}
	},
	created() {
		this.init()
	},
	methods: {
		async init() {
			// console.log('url', this.$route.query)
			// const qr = this.$route.query.qr
			// const agt = this.$route.query.agt
			// const ip = 'noip'
			// const page = 'h5home'
			// if (qr === '1') {
			//   evtlogadd('scanQr1', this.theUA, ip, page)
			// }
			// if (qr === '2') {
			//   evtlogadd('wexinh5', this.theUA, ip, page)
			// }
			// if (agt) {
			//   localStorage.setItem('agent', agt)
			// }
			const isloginRes = await islogin()
			const username = localStorage.getItem('username')
			// console.log(username)

			if (isloginRes.login_status && username) {
				// Toast.loading('已经登陆')
				// const b64u = Base64.encode(username)
				// console.log(username)
				this.$router.push({
					path: '/user'
				})
				this.unlogin = false
			} else {
				// localStorage.clear()
				this.unlogin = true
			}
			if (!isloginRes.login_status && username) {
				this.unlogin = true

				localStorage.clear()
			}
			if (isloginRes.login_status && !username) {
				this.unlogin = true

				// Toast.fail('登录过期\n请重新登陆')
				logout().then(
					() => {

					}
				)
			}
		},
		login() {
			this.$router.push({
				path: '/login'
			})
		},
usercenter() {
			this.$router.push({
				path: '/user'
			})
		}
	}
}
</script>

<style lang="less" scoped>
#homev2 {
  position: relative;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

.bg-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1;
  overflow: hidden;
}

.bg-image {
  width: 100%;
  height: 100%;
  object-fit: fill;
  object-position: center;
}

.title-image {
  position: absolute;
  top: 68px;
  left: 50%;
  transform: translateX(-50%);
  width: 247px;
}

.middle {
  position: relative;
  z-index: 2;
  width: 100vw;
  height: calc(100vh - 7.5vh);
  margin-top: 7.5vh;
  
  .login {
    display: block;
    margin-top: 55.5vh;
    margin-left: auto;
    margin-right: auto;
    width: 80vw;
    height: 54px;
    background: #f2826a;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    border: none;
    border-radius: 27px;
    cursor: pointer;
  }
  
  .card {
    position: fixed;
    color: white;
    width: 90vw;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 35vh;
    border-radius: 2px;
    text-align: center;
    vertical-align: middle;
  }
}

.bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 7.5vh;
  width: 100vw;
  background-color: rgba(255, 255, 255, 0.11);
  z-index: 3;

  .active {
    color: rgba(0,0,0,1)
  }

  .normal {
    color: rgba(102,102,102,1);
  }
}

.active-icon {
  width: 47px;
  height: 43px;
  background: linear-gradient(180deg,rgba(255,51,51,1),rgba(255,117,117,1));
}

h1 {
  color: white;
  text-align: center;
}
</style>

